import { useSettingIsPerfAppSemDiscoverTreatment } from "@faire/retailer-visitor-shared/settings/useSettingPerfAppSemDiscover";
import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";

export const useSettingDiscoverPageImprovements = () => {
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const isPerfAppSemDiscoverTreatment =
    useSettingIsPerfAppSemDiscoverTreatment();
  return (
    !isPerfAppSemDiscoverTreatment && isLoggedOutDiscoverPage
  );
};
